import { connect } from 'react-redux';
import EmailObjectLabel from 'src/components/common/contentEditor/EmailObjectLabel';

const mapStateToProps = state => ({
  contentValidity: state.massAction.contentValidity,
});

export default connect(mapStateToProps)(EmailObjectLabel);
